export default "__VITE_ASSET__Mzg$WGiT__"